import ngAnnotate from '../ngAnnotate.macro';

angular.module('bb.almanac').factory('AlmanacService', AlmanacService);

ngAnnotate(AlmanacService);

function AlmanacService($resource) {
  const AlmanacEvent = $resource('/external/dash/:dashboardId/almanac/events', {
    dashboardId: '@dashboardId',
  });
  const RetsAlmanacEvent = $resource('/external/rets/:retsId/almanac/events', {
    retsId: '@retsId',
  });
  const AlmanacSubscription = $resource(
    '/external/dash/:dashboardId/almanac/subscriptions',
    { dashboardId: '@dashboardId' },
  );
  const AuthStatus = $resource(
    '/external/dash/:dashboardId/almanac/auth_status',
    { dashboardId: '@dashboardId' },
  );
  const RetsAuthStatus = $resource(
    '/external/rets/:retsId/almanac/auth_status',
    { retsId: '@retsId' },
  );

  const getAuthStatus = ({ dashboardId, retsId }) => {
    if (dashboardId) {
      return AuthStatus.get({ dashboardId }).$promise;
    }
    return RetsAuthStatus.get({ retsId }).$promise;
  };

  const createEvent = ({ dashboardId, retsId }, appointmentId) => {
    if (dashboardId) {
      return AlmanacEvent.save({ dashboardId, appointmentId }, {}).$promise;
    }
    return RetsAlmanacEvent.save({ retsId, appointmentId }, {}).$promise;
  };

  const findAlmanacEvent = ({ dashboardId, retsId }, appointmentId) => {
    if (dashboardId) {
      return AlmanacEvent.get({ dashboardId, appointmentId }).$promise;
    }
    return RetsAlmanacEvent.get({ retsId, appointmentId }).$promise;
  };

  const subscribeToListing = dashboardId =>
    AlmanacSubscription.save({ dashboardId }, {}).$promise;

  const unsubscribeFromListing = dashboardId =>
    AlmanacSubscription.delete({ dashboardId }, {}).$promise;

  const findAlmanacSubscription = (dashboardId, listingId) =>
    AlmanacSubscription.get({ dashboardId, listingId }).$promise;

  return {
    getAuthStatus,
    createEvent,
    findAlmanacEvent,
    subscribeToListing,
    unsubscribeFromListing,
    findAlmanacSubscription,
  };
}
